var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.inputContainerClass},[_c('v-textarea',{ref:_vm.name,class:_vm.inputClass,attrs:{"label":_vm.label,"id":_vm.id,"name":_vm.name,"placeholder":_vm.placeHolder},on:{"input":function($event){return _vm.handleInput(_vm.content)}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }